export const PUSH_NOTIFICATIONS_SUBJECT = {
  AUTH_3DS: 'AUTH_3DS',
  CARD_SENSITIVE_DATA_AUTHORIZATION: 'CARD_SENSITIVE_DATA_AUTHORIZATION',
  CARD_SENSITIVE_DATA_PIN_AUTHORIZATION: 'CARD_SENSITIVE_DATA_PIN_AUTHORIZATION',
  CARD_APPLICATION_APPROVED: 'CARD_APPLICATION_APPROVED', // deprecated
  CARD_AVAILABLE: 'CARD_AVAILABLE',
  CARD_TRANSACTION_CREATED: 'CARD_TRANSACTION_CREATED',
  CARD_TRANSACTION_REVERTED: 'CARD_TRANSACTION_REVERTED',
  CARD_ELIGIBLE_USER_CREATED: 'CARD_ELIGIBLE_USER_CREATED',
  CARD_BLOCKED: 'CARD_BLOCKED',
  CARD_LATE_INVOICE_PAYMENT: 'CARD_LATE_INVOICE_PAYMENT',
  CARD_INVOICE_CREATED: 'CARD_INVOICE_CREATED',
  DEPOSIT_RECEIVED: 'DEPOSIT_RECEIVED',
  TRADE_MATCHED: 'TRADE_MATCHED',
  STAKING_REWARD_RECEIVED: 'STAKING_REWARD_RECEIVED',
  REFERRAL_SIGNUP_BONUS: 'REFERRAL_SIGNUP_BONUS',
  REFERRAL_TRADE_COMMISSION: 'REFERRAL_TRADE_COMMISSION',
  WITHDRAWAL_SENT: 'WITHDRAWAL_SENT',
  CARD_BIRTHDAY_GIFT_AVAILABLE: 'CARD_BIRTHDAY_GIFT_AVAILABLE',
  KYC_RENEWAL_REQUEST: 'KYC_RENEWAL_REQUEST',
  PRICE_VOLATILITY: 'PRICE_VOLATILITY'
};

export const PUSH_NOTIFICATIONS_SUBJECTS = Object.values(PUSH_NOTIFICATIONS_SUBJECT);

export const isCardAuthorization = notification =>
  [
    PUSH_NOTIFICATIONS_SUBJECT.AUTH_3DS,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_SENSITIVE_DATA_AUTHORIZATION,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_SENSITIVE_DATA_PIN_AUTHORIZATION
  ].includes(notification.subject);

export const isCardNotificationToRedirect = notification =>
  [
    PUSH_NOTIFICATIONS_SUBJECT.CARD_APPLICATION_APPROVED,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_AVAILABLE,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_TRANSACTION_CREATED,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_TRANSACTION_REVERTED,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_BLOCKED,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_ELIGIBLE_USER_CREATED,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_LATE_INVOICE_PAYMENT,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_BIRTHDAY_GIFT_AVAILABLE,
    PUSH_NOTIFICATIONS_SUBJECT.CARD_INVOICE_CREATED
  ].includes(notification.subject);

export const isReferral = notification =>
  [
    PUSH_NOTIFICATIONS_SUBJECT.REFERRAL_SIGNUP_BONUS,
    PUSH_NOTIFICATIONS_SUBJECT.REFERRAL_TRADE_COMMISSION
  ].includes(notification.subject);
